import React from "react";
import { Link } from "react-router-dom";
import "./InvestAfricaPage.scss";

const services = [
    {
        number: "01",
        title: "Market Entry",
        description:
            "Explore opportunities across African markets with a clearer understanding of the local business environment.",
        items: [
            "Market exploration and opportunity assessment",
            "Local business connections",
            "Market entry planning",
        ],
    },
    {
        number: "02",
        title: "Strategic Partnerships",
        description:
            "Build relationships with businesses and collaborators whose goals align with yours.",
        items: [
            "Identification of potential partners",
            "Business introductions",
            "Partnership development",
        ],
    },
    {
        number: "03",
        title: "Project Development",
        description:
            "Move from an initial idea toward a practical project, connecting business objectives with technology.",
        items: [
            "Project concept and scope",
            "Technology planning",
            "Coordination with project partners",
        ],
    },
];

const steps = [
    {
        title: "Understand Your Goals",
        description:
            "We start with your business, the opportunity you want to explore, and the outcomes you hope to achieve.",
    },
    {
        title: "Explore the Opportunity",
        description:
            "Together, we identify relevant markets, potential relationships, and the questions that need answering.",
    },
    {
        title: "Define the Next Steps",
        description:
            "We agree on a practical scope, responsibilities, and a path toward developing the opportunity.",
    },
];

const InvestAfricaPage = () => {
    return (
        <div className="invest-page">
            <section
                className="invest-page__hero"
                aria-labelledby="invest-page-title"
            >
                <div className="invest-page__container">
                    <p className="invest-page__eyebrow">
                        Techadive Invest Africa
                    </p>

                    <h1 id="invest-page-title">
                        Connecting Global Innovation with{" "}
                        <span>African Opportunity.</span>
                    </h1>

                    <p className="invest-page__lead">
                        We connect international businesses with opportunities across
                        Africa through market exploration, strategic partnerships,
                        and technology-led project development.
                    </p>

                    <div className="invest-page__actions">
                        <Link
                            className="invest-page__button invest-page__button--primary"
                            to="/contact"
                        >
                            Discuss an Opportunity
                            <span aria-hidden="true">↗</span>
                        </Link>

                        <a
                            className="invest-page__button invest-page__button--secondary"
                            href="#invest-services"
                        >
                            Explore Our Approach
                            <span aria-hidden="true">↓</span>
                        </a>
                    </div>

                    <div className="invest-page__hero-note">
                        <span aria-hidden="true" />
                        Market Entry · Partnerships · Project Development
                    </div>
                </div>
            </section>

            <section
                className="invest-page__section"
                aria-labelledby="invest-introduction-title"
            >
                <div className="invest-page__container invest-page__split">
                    <div>
                        <p className="invest-page__eyebrow">
                            A Connection Built on Purpose
                        </p>

                        <h2 id="invest-introduction-title">
                            From Interest to <span>Opportunity.</span>
                        </h2>
                    </div>

                    <div className="invest-page__body">
                        <p>
                            Entering a new market starts with understanding its context:
                            the businesses, relationships, and practical needs that
                            shape an opportunity.
                        </p>

                        <p>
                            Techadive Invest Africa brings our technology perspective
                            into that conversation. We work with businesses to explore
                            connections and shape projects around clear objectives.
                        </p>
                    </div>
                </div>
            </section>

            <section
                className="invest-page__section"
                id="invest-services"
                aria-labelledby="invest-services-title"
            >
                <div className="invest-page__container">
                    <div className="invest-page__section-header">
                        <p className="invest-page__eyebrow">How We Can Help</p>

                        <h2 id="invest-services-title">
                            Supporting Your <span>Next Move.</span>
                        </h2>
                    </div>

                    <ul className="invest-page__grid">
                        {services.map((service) => (
                            <li className="invest-page__card" key={service.number}>
                <span className="invest-page__number" aria-hidden="true">
                  {service.number}
                </span>

                                <h3>{service.title}</h3>
                                <p>{service.description}</p>

                                <ul className="invest-page__items">
                                    {service.items.map((item) => (
                                        <li key={item}>{item}</li>
                                    ))}
                                </ul>
                            </li>
                        ))}
                    </ul>
                </div>
            </section>

            <section
                className="invest-page__section"
                aria-labelledby="invest-process-title"
            >
                <div className="invest-page__container">
                    <div className="invest-page__section-header">
                        <p className="invest-page__eyebrow">Our Approach</p>

                        <h2 id="invest-process-title">
                            A Clear Path <span>Forward.</span>
                        </h2>
                    </div>

                    <ol className="invest-page__grid invest-page__steps">
                        {steps.map((step, index) => (
                            <li className="invest-page__step" key={step.title}>
                <span className="invest-page__number" aria-hidden="true">
                  {String(index + 1).padStart(2, "0")}
                </span>

                                <h3>{step.title}</h3>
                                <p>{step.description}</p>
                            </li>
                        ))}
                    </ol>
                </div>
            </section>

            <section
                className="invest-page__section"
                aria-labelledby="invest-contact-title"
            >
                <div className="invest-page__container">
                    <div className="invest-page__contact">
                        <p className="invest-page__eyebrow">
                            Start a Conversation
                        </p>

                        <h2 id="invest-contact-title">
                            What Would You Like to <span>Explore?</span>
                        </h2>

                        <p>
                            Tell us about your business, the markets you’re interested
                            in, and the project or partnership you have in mind.
                        </p>

                        <Link
                            className="invest-page__button invest-page__button--primary"
                            to="/contact"
                        >
                            Connect with Techadive
                            <span aria-hidden="true">↗</span>
                        </Link>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default InvestAfricaPage;